import type { TextData } from './types';

export function isValidData(value: unknown): value is TextData {
  if (typeof value !== 'object' || value === null) return false;
  const v = value as Record<string, unknown>;
  return (
    (typeof v.text === 'string' || (typeof v.text === 'object' && v.text !== null)) &&
    typeof v.fontSize === 'number' &&
    (v.fontWeight === 400 || v.fontWeight === 500 || v.fontWeight === 700) &&
    typeof v.color === 'string' &&
    (v.textAlign === 'left' || v.textAlign === 'center' || v.textAlign === 'right')
  );
}
